import useCheckPermission from "@hooks/useCheckPermission";

const withCheckPermission = (props) => (WrappedComponent) => {
    return (wrappedProps) => {
        const permissions = {};

        if (Array.isArray(props)) {
            props.forEach(({ scope, domain }) => {
                const permissionKey = `${domain.toUpperCase()}_PERMISSIONS`;
                permissions[permissionKey] = useCheckPermission({ scope, domain });
            });
        }

        return <WrappedComponent {...wrappedProps} checkedPermissions={permissions} />;
    };
};

export default withCheckPermission;
